"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UISliderTrackSegment = exports.getTrackColorFromProps = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _Props = require("../../utils/Props");

var _Styles = require("../../utils/Styles");

// avoid setting props w/ same names as valid HTML attributes (like `width`) on div
var CleanDiv = (0, _Props.omitProps)(function (props) {
  return _react.default.createElement("div", props);
}, ['left', 'lineStyle', 'width', 'color', 'restricted', 'disabled']);

var getTrackColorFromProps = function getTrackColorFromProps(props) {
  var value = props.value,
      disabled = props.disabled,
      restricted = props.restricted,
      readOnly = props.readOnly;

  if (value <= 0) {
    if (disabled || readOnly) {
      return _colors.KOALA;
    }

    if (!restricted) {
      return _colors.CALYPSO;
    }
  }

  return _colors.BATTLESHIP;
};

exports.getTrackColorFromProps = getTrackColorFromProps;
var BORDER_WIDTH_BY_SIZE = {
  md: 1,
  lg: 2
};

var getBorderWidthForSize = function getBorderWidthForSize(size) {
  return BORDER_WIDTH_BY_SIZE[size] || 0;
};

var UISliderTrackLine = (0, _styledComponents.default)(CleanDiv).withConfig({
  displayName: "UISliderTrack__UISliderTrackLine",
  componentId: "elol62-0"
})(["border-color:", ";border-style:", ";border-width:", ";margin:0 ", ";"], function (props) {
  return props.color;
}, function (props) {
  return props.lineStyle;
}, function (props) {
  return (0, _Styles.toPx)(getBorderWidthForSize(props.size));
}, function (props) {
  return (0, _Styles.toPx)(getBorderWidthForSize(props.size));
});

if (process.env.NODE_ENV !== 'production') {
  UISliderTrackLine.propTypes = {
    color: _propTypes.default.string,
    lineStyle: _propTypes.default.oneOf(['solid', 'dashed']),
    size: _propTypes.default.oneOf(['md', 'lg'])
  };
}

var UISliderTrackContainer = (0, _styledComponents.default)(CleanDiv).withConfig({
  displayName: "UISliderTrack__UISliderTrackContainer",
  componentId: "elol62-1"
})(["position:absolute;top:0;bottom:0;left:", ";width:", ";cursor:", ";& ", "{position:absolute;top:", ";right:0;left:0;}"], function (props) {
  return (0, _Styles.toPercent)(props.left);
}, function (props) {
  return (0, _Styles.toPercent)(props.width);
}, function (props) {
  return props.restricted || props.disabled ? 'not-allowed' : undefined;
}, UISliderTrackLine, function (props) {
  return props.size === 'lg' ? '8px' : '6px';
});

if (process.env.NODE_ENV !== 'production') {
  UISliderTrackContainer.propTypes = {
    left: _propTypes.default.number,
    width: _propTypes.default.number,
    size: _propTypes.default.oneOf(['md', 'lg']),
    disabled: _propTypes.default.bool,
    restricted: _propTypes.default.bool,
    readOnly: _propTypes.default.bool
  };
}

var UISliderTrackSegment = function UISliderTrackSegment(props) {
  var size = props.size,
      restricted = props.restricted,
      disabled = props.disabled,
      readOnly = props.readOnly,
      left = props.left,
      width = props.width,
      rest = (0, _objectWithoutProperties2.default)(props, ["size", "restricted", "disabled", "readOnly", "left", "width"]);
  var color = getTrackColorFromProps(props);
  var lineStyle = props.restricted ? 'dashed' : 'solid';
  return _react.default.createElement(UISliderTrackContainer, Object.assign({
    size: size,
    left: left,
    width: width,
    disabled: disabled,
    readOnly: readOnly,
    restricted: restricted
  }, rest), _react.default.createElement(UISliderTrackLine, {
    size: size,
    color: color,
    lineStyle: lineStyle
  }));
};

exports.UISliderTrackSegment = UISliderTrackSegment;
UISliderTrackSegment.propTypes = Object.assign({}, UISliderTrackContainer.propTypes, {
  value: _propTypes.default.oneOf([-1, 0, 1])
});
UISliderTrackSegment.defaultProps = {
  value: 0,
  size: 'md',
  disabled: false,
  restricted: false
};
UISliderTrackSegment.displayName = 'UISliderTrackSegment';